import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { en } from '@/locales/en';
import { th } from '@/locales/th';

export const SUPPORTED_LOCALES = ['en', 'th'] as const;
export const LOCALE_STORAGE_KEY = 'wped.locale';

const stored =
  typeof localStorage !== 'undefined' ? localStorage.getItem(LOCALE_STORAGE_KEY) : null;

void i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    th: { translation: th },
  },
  lng: stored ?? 'th', // Thai is the default; English remains as a fallback for any missing keys.
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
  returnNull: false,
});

i18n.on('languageChanged', (lng) => {
  if (typeof document !== 'undefined') document.documentElement.lang = lng;
  if (typeof localStorage !== 'undefined') localStorage.setItem(LOCALE_STORAGE_KEY, lng);
});

export default i18n;
